import type { Form, FormField } from '../../interfaces/form.interface';

/** Provides read-only lookup helpers for form fields. */
export class FormFieldFinder<T> {
    constructor(private readonly form: Form<T>) {}

    public getFields(): FormField<T>[] {
        return this.form.sections.flatMap(section => section.fields);
    }

    public getFieldByControlName(controlName: string | undefined): FormField<T> | undefined {
        return this.getFields().find(field => field.name === controlName);
    }
}
